import { binarySearch } from "./binarySearch";

/** @type {(scrollTop: number) => (element: HTMLElement) => number} */
const findVisible = scrollTop => element => {
	const parentTop = element.parentElement.offsetTop;
	const ownTop = element.offsetTop;
	const { scrollHeight } = element;
	return Math.round((scrollTop - ownTop + parentTop) / scrollHeight);
};

/** @type {(element: HTMLElement) => HTMLElement | undefined} */
export const findFirstVisibleChild = (element, scrollTop) => {
	const children = Array.from(element.childNodes);
	return binarySearch(children, findVisible(scrollTop));
};
